//  Copyright © Veeam Software Group GmbH

import { useMemo } from 'react';

import type { CollectionToolbarItem } from '@veeam/components';
import type { RestoreSessionEventsFilter } from 'services/restoreService';

import { createConfigMaker, createToolbarFilters } from 'infrastructure/grid';
import { statusIconMap } from '../helpers/mappers';
import { RestoreSessionEventsStatus } from 'services/restoreService';

import type { Resources } from '../../../../../infrastructure/resources';

function createFilter(resources: Resources['features']['RestoreSessions']['EventsGrid']): CollectionToolbarItem[] {
    const configMaker = createConfigMaker<RestoreSessionEventsFilter>();
    const searchConfig = configMaker.search('search', { fieldConfig: { placeholder: resources.filter.message } });
    const statusesConfig = configMaker.basic('status', {
        title: resources.filter.statusTitle,
        items: [
            { title: resources.statuses.running, icon: statusIconMap.Running, value: RestoreSessionEventsStatus.Running },
            { title: resources.statuses.success, icon: statusIconMap.Success, value: RestoreSessionEventsStatus.Success },
            { title: resources.statuses.warning, icon: statusIconMap.Warning, value: RestoreSessionEventsStatus.Warning },
            { title: resources.statuses.failed, icon: statusIconMap.Failed, value: RestoreSessionEventsStatus.Failed },
        ],
    });
    return createToolbarFilters(searchConfig, statusesConfig);
}

export const useFilter = (resources: Resources['features']['RestoreSessions']['EventsGrid']): CollectionToolbarItem[] =>
    useMemo(() => createFilter(resources), [resources]);
